export default "__VITE_ASSET__DPlX4jvJ__"